import React from "react";
import useGlobalHook from "use-global-hook";

import * as actions from "./action";

const initialState = {
  status: 200,
  isLoading: false,
  message: "",
  total_amount: {},
  saldo: {},
  rekening: {},
  header: {},
  headerHasRelease: {},
  data: [],
  usersStatus: [],
  lastPage: false,
  type: [],
  module: [],
};

const MyIncomeStore = useGlobalHook(React, initialState, actions);

export default MyIncomeStore;
